import React from 'react';

import { Form, Button, Input, Segment, Checkbox, Grid } from 'semantic-ui-react';

import { SortableElement } from 'react-sortable-hoc';

import MarkdownField from '../../../../../../../fields/MarkdownField';
import { NAME_FIELD_PLACEHOLDER } from '../../EditTextBlock/EditTextBlock.constants';

import './SortableAccordionItem.scss';

const SortableAccordionItem = SortableElement(
  ({
    id,
    itemData,
    itemIndex,
    onTitleChange,
    onContentChange,
    onRemove,
    onActiveChange,
    showDelete,
    DragHandle,
  }) => {
    const { isActive, title = {}, content = {} } = itemData;
    const { content: titleContent } = title;
    const { content: contentContent } = content;
    const titleId = `${id}-title`;
    const contentId = `${id}-content`;

    return (
      <Segment className="sortable-item">
        <Grid>
          <Grid.Column width={1} verticalAlign="top" className="drag-handle-container">
            <DragHandle />
          </Grid.Column>
          <Grid.Column width={15}>
            <Form>
              <Form.Field>
                <label htmlFor={titleId}>Title</label>
                <Input
                  id={titleId}
                  placeholder={NAME_FIELD_PLACEHOLDER}
                  value={titleContent}
                  maxLength={255}
                  onChange={(e, { value }) => onTitleChange(itemIndex, value)}
                />
              </Form.Field>
              <Form.Field>
                <label htmlFor={contentId}>Content</label>
                <MarkdownField
                  id={contentId}
                  value={contentContent}
                  onChange={(value) => onContentChange(itemIndex, value)}
                  options={{ minHeight: '50px' }}
                />
              </Form.Field>
              <Form.Field>
                <Checkbox
                  toggle
                  label="Open by default"
                  checked={isActive}
                  onChange={(e, { checked }) => onActiveChange(itemIndex, checked)}
                />
              </Form.Field>
              {showDelete && (
                <div className="button-container">
                  <Button icon="trash" onClick={() => onRemove(itemIndex)} basic />
                </div>
              )}
            </Form>
          </Grid.Column>
        </Grid>
      </Segment>
    );
  },
);

export default SortableAccordionItem;
